import { Box } from '@mui/material'

export const VotedIcon = (props) => {
  return (
    <Box {...props}>
      <img src='/voted.svg' />
    </Box>
  )
}
